import { API_AUTH, setTokenGlobal } from "./common";
import { withCookies, Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}
export default {
  saveKho: (params) => API_AUTH.post("kho/saveStore", params),
  getDanhSachKho: (params) => API_AUTH.get("kho/getStoreActiveSearch", params),
  getChiTietKho: (params) =>
    API_AUTH.get("kho/getStoreDetail?storeId=" + params),
  deleteKho: (params) => API_AUTH.post("kho/deleteStore?storeId=" + params),
  khoaMoKhoa: (params) =>
    API_AUTH.post("kho/changeStoreStatus?storeId=" + params),
};
